import { MenuItem as FASTMenuItem } from '@microsoft/fast-components';
import { foundationMenuItemStyles as styles } from './menu-item.styles';
import { foundationMenuItemTemplate as template } from './menu-item.template';
/**
 * @tagname %%prefix%%-menu-item
 */
export class MenuItem extends FASTMenuItem {
    connectedCallback() {
        super.connectedCallback();
        this.addEventListener('click', () => this.$emit('onMenuClick'));
    }
}
// explicitly declaring for extensibility
export const foundationMenuItemShadowOptions = undefined;
export const defaultMenuItemConfig = {
    expandCollapseGlyph: `
    <svg
      class="expand-collapse-glyph"
      part="expand-collapse-glyph"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.023 15.273L11.29 8 4.023.727l.704-.704L12.71 8l-7.984 7.977-.704-.704z"
      />
    </svg>
  `,
};
/**
 * The Foundation Menu Item
 *
 * @public
 * @remarks
 * HTML Element: \<foundation-menu-item\>
 */
export const foundationMenuItem = MenuItem.compose(Object.assign({ baseName: 'menu-item', template,
    styles, shadowOptions: foundationMenuItemShadowOptions }, defaultMenuItemConfig));
